"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.http = void 0;
var container_1 = require("../container/container");
var getCookie_1 = require("../utils/env/getCookie");
var CollectionsSdkError_1 = require("./CollectionsSdkError");
var xsrfProtectionMethods = ['POST', 'PUT', 'DELETE', 'PATCH'];
function http(_a) {
    var _b = _a.method, method = _b === void 0 ? 'GET' : _b, url = _a.url, _c = _a.params, params = _c === void 0 ? {} : _c, restData = __rest(_a, ["method", "url", "params"]);
    var makeRequest = function () {
        var isProtected = xsrfProtectionMethods.includes(method);
        return container_1.siteTokenPromise.then(function (siteToken) {
            if (siteToken) {
                params = __assign(__assign({}, params), { site_token: siteToken });
            }
            var xsrfCookie = getCookie_1.getCookie('XSRF-TOKEN');
            var headers = xsrfCookie && isProtected
                ? {
                    'X-XSRF-TOKEN': xsrfCookie,
                }
                : {};
            return container_1.transport(__assign(__assign({}, restData), { params: params,
                method: method,
                headers: headers, url: "" + container_1.apiUrl + url, withCredentials: true })).catch(function (error) {
                var _a, _b;
                var status = error && 'status' in error ? error.status : (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status;
                var data = error && 'data' in error ? error.data : (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data;
                var defaultMessage = 'Request failed' + (status ? " with status code " + status : '');
                var message = "Simple Collections Sdk: " + ((data === null || data === void 0 ? void 0 : data.message) || defaultMessage);
                if (status === 403) {
                    throw new CollectionsSdkError_1.NotAllowedCollectionsSdkError(message, status, error);
                }
                if (status === 404) {
                    throw new CollectionsSdkError_1.NotFoundCollectionsSdkError(message, status, error);
                }
                throw new CollectionsSdkError_1.CollectionsSdkError(message, status, error);
            });
        });
    };
    return makeRequest().then(function (resp) { return resp.data; });
}
exports.http = http;
//# sourceMappingURL=http.js.map